/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactElement, useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import * as Analytics from 'core/common/analytics'
import { TKindPathName } from 'core/common/analytics'
import { Container } from 'core/components/Core'
import AppLoading from 'core/containers/App/AppLoading'
import { getMigrationStatus } from 'core/services/http'

const AppLayout: React.FC<{ children: ReactElement; custom?: any }> = ({ children, custom }) => {
  const [isCheckingForMigration, setIsCheckingForMigration] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const pathname = location.pathname.replace(
      /([0-9]+([a-zA-Z]+[0-9]+)+)/gm,
      ':id'
    ) as TKindPathName

    Analytics.pageViewEvent(pathname)
  }, [location])

  const checkSellerMigration = useCallback(() => {
    setIsCheckingForMigration(true)

    getMigrationStatus()
      .then(({ data }) => {
        sessionStorage.setItem('isSellerMigrated', data.migrated)
      })
      .catch(() => {
        sessionStorage.removeItem('isSellerMigrated')
      })
      .finally(() => {
        setIsCheckingForMigration(false)
      })
  }, [])

  useEffect(() => {
    if (!custom?.checkSellerMigration) return

    checkSellerMigration()
  }, [custom?.checkSellerMigration, checkSellerMigration])

  return (
    <div className="pt-12">
      <Container className="p-0" style={{ maxWidth: '1290px' }}>
        {isCheckingForMigration ? <AppLoading /> : children}
      </Container>
    </div>
  )
}

export default AppLayout
